module.exports = __webpack_public_path__ + "static/media/2.4d21cb58.png";